import { orderCollections } from '../../../services/collections';

export function getSubcollectionIds(items) {
    return (items || [])
        .map((item) => (typeof item === 'object' && item ? item.id : null))
        .filter(Boolean);
}

/** Persist subcategory display order (new items should be last in the list). */
export function persistSubcollectionOrder(storeId, items) {
    const ids = getSubcollectionIds(items);
    if (!ids.length) return Promise.resolve();
    return orderCollections(storeId, ids);
}

export const SUBCOLLECTION_SORTABLE_PROPS = {
    useDragHandle: true,
    lockAxis: 'y',
    distance: 8,
    transitionDuration: 200,
    helperClass: 'sortable-subcollection-helper',
};

export function getSubcollectionHelperDimensions({ node }) {
    const surface = node.querySelector('.subcollection-sortable-surface');
    const target = surface || node;
    const { width, height } = target.getBoundingClientRect();
    return { width, height };
}
